import {
  INIT_ROOT,
  TOGGLE_OPTION_SUCCESS,
  TOGGLE_OPTION_CONFLICT_RESOLVE,
  UPDATE_CONFIG_SUCCESS,
  START_OVER,
} from '../actionTypes';

export default function wasOptionToggled(state, action) {
  switch (action.type) {
    case INIT_ROOT:
      return action.payload.wasOptionToggled || false;
    case TOGGLE_OPTION_SUCCESS:
    case TOGGLE_OPTION_CONFLICT_RESOLVE:
      return true;
    case UPDATE_CONFIG_SUCCESS:
    case START_OVER:
      return false;
    default:
      return state || false;
  }
}
